const template = '<router-link :to="destination"><slot></slot></router-link>';

export default {
	template,
	props: ['to'],
	computed: {
		destination() {
			if (typeof this.to !== 'string') return this.to;
			if (/^\/[a-z]{2}(\/|\?|$)/.test(this.to)) return this.to;
			return this.to.replace(/\/$/, '') || '/';
		}
	}
}